import type { DeliveryZone, WeekDayNumber } from '@@partner:types:app'

import React, { useState } from 'react'
import { Button, SelectPicker } from 'rsuite'

interface Props {
  onSelect: (day: WeekDayNumber) => void
  deliveryZones: DeliveryZone[]
}

export default function OtherZoneSlotsCopier ({ 
  onSelect,
  deliveryZones
}: Props) {
  const [ zoneId, setZoneId ] = useState<WeekDayNumber>(1)

  const data = deliveryZones.map(zone => ({
    label: `${zone.name} (${zone.id})`,
    value: zone.id
  }))
  return (
    <div className="flex align-middle my-2">
      <Button
        size="xs"
        appearance="primary"
        color="violet"
        onClick={() => onSelect(zoneId)}
      >
        Скопировать из зоны
      </Button>
      <SelectPicker
        size="xs"
        cleanable={false}
        searchable={false}
        value={zoneId}
        onSelect={setZoneId}
        data={data}
      ></SelectPicker>
    </div>
  )
}
